import { resolve } from 'styled-jsx/css';

/* istanbul ignore next */
export const fullWidth = resolve`
          /* Makes sure that we make this the full width of the screen, including
          scrollbar */
          width: calc(100vw + (100vw - 100%));
          position: relative;
          left: calc(-50vw + 50%);
          `;

// Allows us to make an element full width, even if the parent element
// has a smaller width
export const flexBoxFullWidthCSS = resolve`
align-self: center;
width: 100vw;
          `;

export default { fullWidth };
